import React from 'react';
export var OverflowContext = /*#__PURE__*/React.createContext(null);